/** @module root/components/accreditation/settings */

import * as STATES                          from './settings.states';
import { IDS }                              from './settings-action-id.constants';
import { frameworkDetails }                 from './framework-details/framework-details.component';

import { headOffices }                      from './enabled-accounts/head-offices/head-offices.component';
import { headOfficesGrid }                  from './enabled-accounts/head-offices/head-offices-grid.component';

import { siteLocations }                    from './enabled-accounts/site-locations/site-locations.component';
import { siteLocationsGrid }                from './enabled-accounts/site-locations/site-locations-grid.component';

import { requirements }                     from './requirements/requirements.component';
import { requirementDetails }               from './requirements/details/requirement-details.component';
import { requirementsImports }              from './requirements/imports/requirements-imports.component';
import { requirementsImportsGrid }          from './requirements/imports/requirements-imports-grid.component';

import { evidenceList }                     from './evidence/evidence-list.component';
import { evidenceGrid }                     from './evidence/evidence-grid.component';
import { evidenceDetails }                  from './evidence/details/evidence-details.component';
import { evidenceApplicableHeadOfficesGrid} from './evidence/details/evidence-applicable-head-offices-grid.component';
import { evidenceRequirementsGrid }         from './evidence/details/evidence-requirements-grid.component';
import { evidenceApplicableSites }          from './evidence/applicable-sites/evidence-applicable-sites.component';
import { evidenceApplicableSitesGrid}       from './evidence/applicable-sites/evidence-applicable-sites-grid.component';
import { evidenceAdd }                      from './evidence/add/evidence-add.component';
import { evidenceImports }                  from './evidence/imports/evidence-imports.component';
import { evidenceImportsGrid }              from './evidence/imports/evidence-imports-grid.component';

import { sloRequiredDocs }                  from './slo-required-docs/slo-required-docs.component';
import { sloRequiredDocsGrid }              from './slo-required-docs/slo-required-docs-grid.component';
import { sloRequiredDocDetails }            from './slo-required-docs/details/slo-required-doc-details.component';
import { sloRequiredDocSectionsGrid }       from './slo-required-docs/details/slo-required-doc-sections-grid.component';
import { sloRequiredDocAdd }                from './slo-required-docs/add/slo-required-doc-add.component';
import { sloRequiredDocsImports }           from './slo-required-docs/imports/slo-required-docs-imports.component';
import { sloRequiredDocsImportsGrid }       from './slo-required-docs/imports/slo-required-docs-imports-grid.component';

export const SETTINGS_MODULE = angular.module(
    'migration.accreditation.settings',
    []
).config(['$uiRouterProvider', ({ stateRegistry }) => {
    Object.values(STATES).map(
        state => stateRegistry.register(state)
    );
}]).component({
    frameworkDetails,

    headOffices,
    headOfficesGrid,

    siteLocations,
    siteLocationsGrid,

    requirements,
    requirementDetails,
    requirementsImports,
    requirementsImportsGrid,

    evidenceList,
    evidenceGrid,
    evidenceDetails,
    evidenceApplicableHeadOfficesGrid,
    evidenceRequirementsGrid,
    evidenceApplicableSites,
    evidenceApplicableSitesGrid,
    evidenceAdd,
    evidenceImports,
    evidenceImportsGrid,

    sloRequiredDocs,
    sloRequiredDocsGrid,
    sloRequiredDocDetails,
    sloRequiredDocSectionsGrid,
    sloRequiredDocAdd,
    sloRequiredDocsImports,
    sloRequiredDocsImportsGrid,

}).run(['$templateCache', ({ put }) => {
    put(IDS.app_accreditation_scheme_settings_framework_details,            '<framework-details></framework-details>');
    put(IDS.app_accreditation_scheme_settings_enabled_head_offices,         '<head-offices></head-offices>');
    put(IDS.app_accreditation_scheme_settings_enabled_site_locations,       '<site-locations></site-locations>');
    put(IDS.app_accreditation_scheme_settings_requirements_list,            '<requirements></requirements>');
    put(IDS.app_accreditation_scheme_settings_requirements_imports,         '<requirements-imports></requirements-imports>');

    put(IDS.app_accreditation_scheme_settings_evidence_list,                '<evidence-list></evidence-list>');
    put(IDS.app_accreditation_scheme_settings_evidence_details,             '<evidence-details></evidence-details>');
    put(IDS.app_accreditation_scheme_settings_evidence_add,                 '<evidence-add></evidence-add>');
    put(IDS.app_accreditation_scheme_settings_evidence_imports,             '<evidence-imports></evidence-imports>');
    put(IDS.app_accreditation_scheme_settings_evidence_applicable_sites,    '<evidence-applicable-sites></evidence-applicable-sites>');

    put(IDS.app_accreditation_scheme_settings_slo_required_docs_list,       '<slo-required-docs></slo-required-docs>');
    put(IDS.app_accreditation_scheme_settings_slo_required_docs_details,    '<slo-required-doc-details></slo-required-doc-details>');
    put(IDS.app_accreditation_scheme_settings_slo_required_docs_add,        '<slo-required-doc-add></slo-required-doc-add>');
    put(IDS.app_accreditation_scheme_settings_slo_required_docs_imports,    '<slo-required-docs-imports></slo-required-docs-imports>');
}]);
